import { Drag, DropList } from 'vue-easy-dnd';

export default {
  name       : 'Flex',
  components : {
    Drag,
    DropList
  },
  props: {
    items              : null,
    direction          : String,
    academicMainId     : null,
    academicMainTypeId : null
  },
  data() {
    return {
      disabledDrag: true
    };
  },
  created() {
    this.$nuxt.$on('mouseOverSection', () => {
      this.disabledDrag = false;
    });

    this.$nuxt.$on('mouseLeaveSection', () => {
      this.disabledDrag = true;
    });
  },
  methods: {
    key(item) {
      if (typeof item === 'object') {
        return item.key;
      } else {
        return item;
      }
    },
    onInsert(event) {
      this.items.splice(event.index, 0, event.data);
    },
    onReorder(event) {
      if (event.to === 0) {
        return false;
      }

      event.apply(this.items);
    },
    remove(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    }
  }
};
